export const exceptGameType = (gameType) => {
  const except = ["PROMOTION"];

  return except.includes(gameType);
};
